import { FieldType } from "@/dentlab/src/pages/form-builder/types/formTypes";

/**
 * Individual tooth data with dropdown values
 */
export interface ToothData {
	toothNumber: number;
	values: Record<string, string>; // Key is dropdown field id, value is selected option value
}

/**
 * Individual appointment data with field values
 */
export interface AppointmentData {
	appointmentId: string;
	values: Record<string, string>; // Key is field id, value is field value
}

/**
 * Type definition for custom form file data
 * `data` (base64 data URL) only lives in the form state; the sent message references the
 * uploaded files via `file_ids`.
 */
export type CustomFormFileType = {
	name: string;
	data?: string;
	type: string;
	size: number;
};

/**
 * Possible field value types based on field type
 */
export type FieldValueType =
	| string // For text, textarea, radio, select, date, time
	| string[] // For checkbox (multiple selections) and file uploads
	| ToothData[] // For odontogram (always uses ToothData format)
	| AppointmentData[] // For appointment field
	| CustomFormFileType[] // For file uploads
	| undefined; // For empty/unset values

/**
 * Interface for a form field value with type information
 */
export interface CustomFormDataValue {
	fieldType: FieldType;
	fieldValue: FieldValueType;
}

/**
 * Interface for form data storage
 */
export interface CustomFormData {
	[key: string]: CustomFormDataValue;
}

export const NEW_VENDOR_ID = "__new__";

/**
 * Form selection interface
 */
export interface FormSelection {
	orgId: string;
	formId: string;
}
